export default function ($context) {
    $context = $context || $(document.body);

    $(document).trigger('update@elkitorg', [$context]);
};
